var $39eb6836bb014970$exports = {};
$39eb6836bb014970$exports = {
    "alert": `Upozorenje`,
    "dismiss": `Odbaci`
};


export {$39eb6836bb014970$exports as default};
//# sourceMappingURL=sr-SP.module.js.map
